export class Candidate {
    candidateId: number;
    panelCandidates: [];
    candidateName: string;
    gender: string;
    email: string;
    contactNo: number;
    address: string;
    dob: string;
    createdDate: string;
    totalMarks: number;
    score: number;
    reportURL: string;
    attemptStatus: string;
    status: number;
    parentId: number;
    panelAssigned: number;
    constructor(candidateName: string, gender: string, email: string, contactNo: number, address: string,
        dob: string, totalMarks: number, score: number, attemptStatus: string, panelCandidates: []) {
        this.candidateName = candidateName;
        this.gender = gender;
        this.email = email;
        this.contactNo = contactNo;
        this.address = address;
        this.dob = dob;
        this.totalMarks = totalMarks;
        this.score = score;
        this.attemptStatus = attemptStatus;
        this.reportURL = "";
        this.parentId = 0;
        this.panelAssigned = 0;
        this.panelCandidates = panelCandidates;
    }
}
